<template>
    <div :class="['customer-state-box', 'drei_60-border-1', border, 'shadow']">
        <div :class="['customer-state-box__icon', background]">
            <v-icon class="drei_60-white-text">{{ icon }}</v-icon>
        </div>
        <div>
            <div class="text-uppercase customer-info-box__title">{{ title }}</div>
            <div
                class="font-weight-bold customer-info-box__text"
                v-for="(t, index) in text"
                :key="`customer-state-text-${index}`"
            >
                {{ t }}
            </div>
            <div class="customer-info-box__target">
                <v-btn
                    v-if="isLeserserviceOrHigher && showAction"
                    :loading="inAction"
                    :disabled="loading"
                    @click="activate"
                    outlined
                    block
                    small
                    class="drei_60-btn ml-0 mr-0"
                >
                    Jetzt aktivieren
                </v-btn>
            </div>

        </div>
    </div>
</template>
<script>
import {
    mapActions, mapMutations, mapState, mapGetters,
} from 'vuex';
import Api from '@/api';

export default {
    name: 'Nutzerstatus',
    props: [
        'ssoId',
        'loading',
        'status',
        'icon',
        'title',
        'text',
        'color',
        'target',
        'targetTitle',
    ],
    computed: {
        ...mapGetters(
            [
                'isLeserserviceOrHigher',
            ],
        ),
        ...mapState('customerDetail', ['inAction']),
        background() {
            const { color } = this.$props;
            return `drei_60-${color}`;
        },
        border() {
            const { color } = this.$props;
            return `drei_60-${color}-border`;
        },
        showAction() {
            return this.status === 'registered';
        },
    },
    methods: {
        ...mapMutations('customerDetail', ['setInAction']),
        ...mapActions('customerDetail', ['getInfo']),
        activate() {
            this.setInAction(true);
            Api.customer.activateCustomer(this.ssoId)
                .then(() => this.success('Benutzer erfolgreich aktiviert.'))
                .catch(() => this.error('Benutzer konnte nicht aktiviert werden.'))
                .finally(() => {
                    this.setInAction(false);
                    this.getInfo();
                });
        },
        ...mapMutations('snackbar', ['success', 'error']),
    },
};

</script>
<style scoped lang="scss">
    .customer-state-box {
        display: flex;
    }
    .customer-state-box__title, .customer-state-box__text {
        flex: none;
    }
    .customer-state-box__target {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-content: baseline;
    }
    .customer-state-box__target .v-btn {
        margin: 0;
        padding: 0;
    }
    .customer-state-box__icon {
        flex: none;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .customer-state-box__icon + div {
        flex: 1;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
</style>
